"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_datepicker_1 = __importDefault(require("react-datepicker"));
var Icon_1 = require("../Icon");
require("react-datepicker/dist/react-datepicker.css");
var months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
var disabledColor = '#fafafa';
// Add ability to update font size
var CustomDatePickerHeader = function (_a) {
    var date = _a.date, decreaseMonth = _a.decreaseMonth, increaseMonth = _a.increaseMonth, prevMonthButtonDisabled = _a.prevMonthButtonDisabled, nextMonthButtonDisabled = _a.nextMonthButtonDisabled;
    return (React.createElement("div", { className: "u-flex u-flexAlignItemsCenter u-flexJustifyBetween u-spaceBottomMd" },
        React.createElement("button", { type: "button", className: "u-colorNeutral9", onClick: decreaseMonth, disabled: prevMonthButtonDisabled },
            React.createElement(Icon_1.Icon, { name: "left" })),
        React.createElement("div", { className: "react-datepicker__current-month u-colorNeutral9" }, months[date.getMonth()] + " " + date.getFullYear()),
        React.createElement("button", { type: "button", className: "u-colorNeutral9", onClick: increaseMonth, disabled: nextMonthButtonDisabled },
            React.createElement(Icon_1.Icon, { name: "right" }))));
};
var DateTimePicker = function (_a) {
    var containerClasses = _a.containerClasses, dateFormat = _a.dateFormat, datetime = _a.datetime, disabled = _a.disabled, excludeTimes = _a.excludeTimes, filterTime = _a.filterTime, inputClasses = _a.inputClasses, onChange = _a.onChange, onBlur = _a.onBlur, openToDate = _a.openToDate, placeholderText = _a.placeholderText, showTimeSelect = _a.showTimeSelect, minDate = _a.minDate;
    return (React.createElement("div", { style: { backgroundColor: "" + (disabled ? disabledColor : '') }, className: "date-time-picker Grid-cell u-flex u-border u-borderRadiusLg u-padSidesMd u-flexJustifyBetween u-flexAlignItemsCenter " + containerClasses, "data-testid": "date-time-picker-id" },
        React.createElement(react_datepicker_1.default, { selected: datetime, onChange: onChange, onBlur: onBlur, showTimeSelect: showTimeSelect, timeIntervals: 15, dateFormat: dateFormat || 'Pp', minDate: minDate, placeholderText: placeholderText || 'mm/ dd / yyyy, -- : -- --', className: "u-borderNone u-padEndsMd " + inputClasses, renderCustomHeader: function (props) { return React.createElement(CustomDatePickerHeader, __assign({}, props)); }, openToDate: openToDate, filterTime: filterTime, excludeTimes: excludeTimes, disabled: disabled }),
        React.createElement(Icon_1.Icon, { mods: "" + (disabled ? 'u-colorNeutral5' : 'u-colorNeutral8'), name: "calendar-today" })));
};
DateTimePicker.defaultProps = {
    containerClasses: '',
    dateFormat: '',
    disabled: false,
    excludeTimes: [],
    filterTime: function () { return true; },
    onBlur: function () { },
    inputClasses: '',
    openToDate: undefined,
    placeholderText: '',
    showTimeSelect: false,
    minDate: undefined,
};
exports.default = DateTimePicker;
